import React, { useMemo, useState, useEffect } from 'react';
import StickyTitle from '../components/StickyTitle.js';
import { MaterialReactTable } from 'material-react-table';
import { useAuth } from '../../AuthContext.js';
import { CSVLink } from 'react-csv';
import { Button } from '@mui/material';
import axios from 'axios';
import CategoryForm from '../components/CategoryForm.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CategoryItem = () => {

    const { userRole } = useAuth()
    const [employee, setEmployee] = useState(true);
    const [showPopup, setshowPopup] = useState(false);
    let [selectedRow, setSelectedRow] = useState(null);

    useEffect(() => {
        if (userRole === "manager") {
            setEmployee(false)
        } else {
            setEmployee(true)
        };
    }, [userRole])

    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchCategory = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/category/all_categories`);
                const responseData = await response.json();
                if (responseData) {
                    setData(responseData.categories);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        fetchCategory();
    }, []);

    const columns = useMemo(
        () => [
            {
                accessorKey: 'id',
                header: 'Category ID',
                size: 100,
            },
            {
                accessorKey: 'categoryname',
                header: 'Category Name',
                size: 100,
            },
        ],
        [],
    );

    const togglePopup = () => {
        setshowPopup(!showPopup)
    }

    const DeleteCategory = async (selectedRowId) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/category/delete_category`, {
                data: {
                    id: selectedRowId
                }
            });
            if (response.status === 200) {
                toast.success(`Category with id: "${selectedRowId}" deleted successfully.`)
            } else {
                toast.error("Failed to delete category.");
            }
        } catch (error) {
            toast.error("Error deleting category");
        }
    };

    return (
        <>
            <StickyTitle title="Categories" button_action={togglePopup} button="New Category" />
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className=' px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>
                <div className="table-filters flex flex-row items-center justify-between mt-3 mb-3">
                    <div className='text-2xl ml-2 font-bold font-poppins'>All Categories</div>
                </div>

                {data ? (<div className="w-full">
                    <MaterialReactTable
                        // enableRowActions
                        enableRowSelection
                        columns={columns}
                        data={data}
                        renderTopToolbarCustomActions={({ table }) => {
                            const handleDelete = () => {
                                const selectedRows = table.getSelectedRowModel().flatRows;

                                if (selectedRows.length === 1) {
                                    selectedRow = selectedRows[0];
                                    const selectedRowId = selectedRow.original.id;
                                    setSelectedRow(selectedRow);
                                    alert('Deleting Category with ID: ' + selectedRowId);
                                    DeleteCategory(selectedRowId)
                                } else {
                                    alert('Please select a single row to delete.');
                                }
                            };

                            return (
                                <div style={{ display: 'flex', gap: '0.5rem' }}>
                                    <Button
                                        color="error"
                                        disabled={!table.getIsSomeRowsSelected()}
                                        onClick={handleDelete}
                                        variant="contained"
                                        sx={employee ? { display: 'none' } : {}}
                                    >
                                        Delete
                                    </Button>
                                    <Button
                                        color="success"
                                        variant="contained"
                                    >
                                        <CSVLink data={data}>Export to CSV</CSVLink>
                                    </Button>
                                </div>
                            )
                        }}
                    />
                </div>) : (null)}
            </div>

            {showPopup && (
                <div className="fixed inset-0 flex items-center justify-center z-50">
                    <div className="absolute inset-0 bg-gray-900 opacity-50"></div>
                    <div className="z-50 bg-white p-6 rounded-md shadow-lg flex flex-col gap-3">
                        <div className="flex justify-end">
                            <button
                                className="text-gray-500 hover:text-gray-700"
                                onClick={togglePopup}
                            >
                                <svg
                                    className="w-6 h-6"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </button>
                        </div>
                        <CategoryForm />
                    </div>
                </div>

            )}
        </>
    );
};

export default CategoryItem;
